// extracted by mini-css-extract-plugin
module.exports = {"select":"lLzWjRrs","isSmall":"FCF2mn2x","isLarge":"_23HQiotI","isDark":"YAF_OZH6"};